/*  eslint-disable no-unused-vars */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fa3 } from '@fortawesome/free-solid-svg-icons';

function CPState3({ s3Done }) {
  return (
    <div className="CPS1" style={{ backgroundColor: s3Done ? 'green' : null }}>
      <div className="CPS1_A1">
        <FontAwesomeIcon icon={fa3} />
      </div>
      <div className="CPS1_A2">
        Add a price
      </div>
    </div>
  );
}

export default CPState3;
/*  eslint-enable no-unused-vars */
